import React from "react";

import {
    Stack,
    Box,
    Text,
    Divider,
    SimpleGrid,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import StatusBadge from "components/Badges/StatusBadge";


const ViewAssessmentDrawer = ({
    isOpen,
    onClose,
    assessment,
}) => {

    return (

        <ReusableDrawer

            isOpen={isOpen}

            onClose={onClose}

            headerContent={
                <h2>
                    View Assessment
                </h2>
            }

            bodyContent={

                !assessment ? null : (

                    <Stack spacing={5}>

                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                                mb={1}
                            >
                                Title
                            </Text>

                            <Text
                                fontWeight="600"
                            >
                                {
                                    assessment.title
                                }
                            </Text>

                        </Box>


                        <Divider />


                        <Box>

                            <Text
                                fontSize="sm"
                                color="gray.500"
                                mb={1}
                            >
                                Description
                            </Text>

                            <Text>
                                {
                                    assessment.description ||
                                    "N/A"
                                }
                            </Text>

                        </Box>


                        <SimpleGrid
                            columns={2}
                            spacing={5}
                        >

                            <Box>

                                <Text
                                    fontSize="sm"
                                    color="gray.500"
                                >
                                    Pass Mark
                                </Text>

                                <Text
                                    fontWeight="600"
                                >
                                    {
                                        assessment.pass_mark
                                    }%
                                </Text>

                            </Box>


                            <Box>

                                <Text
                                    fontSize="sm"
                                    color="gray.500"
                                    mb={2}
                                >
                                    Status
                                </Text>

                                <StatusBadge
                                    label={
                                        assessment.active
                                            ? "Active"
                                            : "Inactive"
                                    }
                                    variant={
                                        assessment.active
                                            ? "success"
                                            : "gray"
                                    }
                                />

                            </Box>

                        </SimpleGrid>

                    </Stack>
                )
            }
        />
    );
};


export default ViewAssessmentDrawer;